module.exports = __webpack_public_path__ + "static/media/ExL-Logo-Rebranddark.77cfbd8c.png";